import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import { push } from 'react-router-redux'
import app from 'containers/app'
import { api } from './api'
import * as actions from './actions'

function uploadCsv(action$) {
  return action$.ofType(actions.uploadCsv.toString())
    .map(action => action.payload)
    .mergeMap(({ file }) => api
      .upload(file)
      .takeUntil(action$.ofType(actions.uploadCsvCancelled.toString()))
      .map(actions.uploadCsvSuccess)
      .startWith(actions.uploadCsvPending())
      .catch(error => {
        app.actions.NotificationActions.pushNotification({
          content: "An error occurred", //TODO: fix error message
          variant: "red",
          sticky: true,
        })

        return Observable.of(actions.uploadCsvFailed({ error }))
      })
    )
}

function startImport(action$, query) {
  return action$.ofType(actions.startCsvImport.toString())
    .map((action) => action.payload)
    .mergeMap(({ id, mapping, createSegment, csvName }) => api
      .start(id, mapping, createSegment, csvName)
      .map(() => {
        app.actions.NotificationActions.pushNotification({ content: "Your CSV import is in progress..." })

        return actions.startCsvImportSuccess()
      })
      .startWith(actions.startCsvImportPending())
      .catch(error => {
        app.actions.NotificationActions.pushNotification({
          content: "An error occurred", //TODO: fix error message
          variant: "red",
          sticky: true,
        })

        return Observable.of(actions.startCsvImportFailed({ error }))
      })
    )
}

function importStartedRedirect(action$) {
  return action$.ofType(actions.startCsvImportPending.toString())
    .mapTo(push('/users'))
}

export const epic = combineEpics(uploadCsv, startImport, importStartedRedirect)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/csv/epic.js